"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.Breadcrumbs = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Breadcrumbs = require("./Breadcrumbs.style");

var Breadcrumbs = function Breadcrumbs(_ref) {
  var crumbs = _ref.crumbs,
      activeCrumb = _ref.activeCrumb;
  var separator = ' > ';
  return /*#__PURE__*/_react.default.createElement(_Breadcrumbs.Wrapper, null, /*#__PURE__*/_react.default.createElement(_Breadcrumbs.CrumbsContainer, null, /*#__PURE__*/_react.default.createElement("span", {
    "data-test": "breadcrumbs"
  }, crumbs.map(function (crumb) {
    return /*#__PURE__*/_react.default.createElement(_Breadcrumbs.Crumb, {
      key: crumb.crumbLabel
    }, /*#__PURE__*/_react.default.createElement(_Breadcrumbs.CrumbLink, {
      to: crumb.pathname
    }, crumb.crumbLabel), /*#__PURE__*/_react.default.createElement(_Breadcrumbs.Separator, null, separator));
  }), /*#__PURE__*/_react.default.createElement(_Breadcrumbs.ActiveCrumb, {
    key: activeCrumb
  }, activeCrumb))));
};

exports.Breadcrumbs = Breadcrumbs;
Breadcrumbs.propTypes = {
  activeCrumb: _propTypes.default.string,
  crumbs: _propTypes.default.arrayOf(_propTypes.default.shape({
    crumbLabel: _propTypes.default.string,
    pathname: _propTypes.default.string
  }))
};
Breadcrumbs.defaultProps = {
  activeCrumb: '',
  crumbs: []
};
var _default = Breadcrumbs;
exports.default = _default;